import React from 'react';
import styled from 'styled-components';
import { columnValueFormatter } from '../../utils';

interface IProps {
  data: string | number;
  dataKey: string | number;
}

const SourceCell = styled.div`
  padding-left: 7.5px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

const RenderSource = ({ data, dataKey }: IProps) => (
  <SourceCell title={data}>{columnValueFormatter(data, dataKey)}</SourceCell>
);

export default React.memo(RenderSource);
